import { useEffect, useRef } from "react";

import { addMarker, createMap } from "./service";
export { default as useMap } from "./use-map";

import "mapbox-gl/dist/mapbox-gl.css";
import "./marker.css";

export default function useMap(locations) {
  const mapRef = useRef();
  const mapContainerRef = useRef();

  useEffect(() => {
    const center = [locations[0].location.lon, locations[0].location.lat];

    mapRef.current = createMap(mapContainerRef.current, {
      zoom: 8,
      center,
    });

    locations.forEach(({ location }) =>
      addMarker(mapRef.current, [location.lon, location.lat]),
    );

    return () => {
      mapRef.current.remove();
    };
  }, []);

  return mapContainerRef;
}
